import _ from 'lodash';
import { BackgroundElementDefinition, BackgroundElementType, BackgroundElementId } from './BackgroundElement/index';
import { PageElementDefinition, PageElementType, PageElementId } from './PageElement/index';
import { GalleryElementDefinition, GalleryElementType } from './GalleryElement/index';
import { MobileGalleryElementDefinition, MobileGalleryElementType } from './MobileGalleryElement/index';
import { HtmlElementDefinition, HtmlElementType } from './HtmlElement/index';
import { IconElementDefinition, IconElementType } from './IconElement/index';
import { ImageElementDefinition, ImageElementType } from './ImageElement/index';
import { RichTextElementDefinition, RichTextElementType } from './RichTextElement/index';
import { ShapeElementDefinition, ShapeElementType } from './ShapeElement/index';
import { TabsElementDefinition, TabsElementType } from './TabsElement/index';
import { MobileTabsElementDefinition, MobileTabsElementType } from './MobileTabsElement/index';
import { TitleElementDefinition, TitleElementType } from './TitleElement/index';
import { VideoElementDefinition, VideoElementType } from './VideoElement/index';
import { MobileVideoElementDefinition, MobileVideoElementType } from './MobileVideoElement/index';
import { CrossSellGalleryElementDefinition, CrossSellGalleryElementType } from './CrossSellGalleryElement/index';
import { MobileCrossSellGalleryElementDefinition, MobileCrossSellGalleryElementType } from './MobileCrossSellGalleryElement/index';
import * as commonElementMethods from 'crazyEditor/core/elements/utils/commonElementMethods';
import * as fontSelectableMethods from 'crazyEditor/core/elements/utils/fontSelectableMethods';

// O(1) access time
export const elementDefinitions = {
  [BackgroundElementType]: BackgroundElementDefinition,
  [PageElementType]: PageElementDefinition,
  [GalleryElementType]: GalleryElementDefinition,
  [MobileGalleryElementType]: MobileGalleryElementDefinition,
  [HtmlElementType]: HtmlElementDefinition,
  [IconElementType]: IconElementDefinition,
  [ImageElementType]: ImageElementDefinition,
  [RichTextElementType]: RichTextElementDefinition,
  [ShapeElementType]: ShapeElementDefinition,
  [TabsElementType]: TabsElementDefinition,
  [MobileTabsElementType]: MobileTabsElementDefinition,
  [TitleElementType]: TitleElementDefinition,
  [VideoElementType]: VideoElementDefinition,
  [MobileVideoElementType]: MobileVideoElementDefinition,
  [CrossSellGalleryElementType]: CrossSellGalleryElementDefinition,
  [MobileCrossSellGalleryElementType]: MobileCrossSellGalleryElementDefinition,
};

_.forEach(elementDefinitions, (elementDefinition) => {
  elementDefinition.methods = _.assign({}, commonElementMethods, elementDefinition.methods);
  if (elementDefinition.elementProps.fontSelectable) {
    elementDefinition.methods = _.assign(elementDefinition.methods, fontSelectableMethods);
  }
});

export const elementTypes = {
  BackgroundElement: BackgroundElementType,
  PageElement: PageElementType,
  GalleryElement: GalleryElementType,
  MobileGalleryElement: MobileGalleryElementType,
  HtmlElement: HtmlElementType,
  IconElement: IconElementType,
  ImageElement: ImageElementType,
  RichTextElement: RichTextElementType,
  ShapeElement: ShapeElementType,
  TabsElement: TabsElementType,
  MobileTabsElement: MobileTabsElementType,
  TitleElement: TitleElementType,
  VideoElement: VideoElementType,
  MobileVideoElement: MobileVideoElementType,
  CrossSellGalleryElement: CrossSellGalleryElementType,
  MobileCrossSellGalleryElement: MobileCrossSellGalleryElementType,
};
export const elementIds = {
  PageElement: PageElementId,
  BackgroundElement: BackgroundElementId
};
